import { ObservableProp } from '@Utils/useClassStore';
import { injectable } from 'inversify';

import type {
  GridCardData,
  IPlaneParent,
  PlaneSize,
  Position2D,
} from '../ModelTypes';
import { PlaneTypes } from '../ModelTypes';
import { PlanePositionSizeAbstract } from './PlanePositionSize';

import container from '~ioc/ioc';

@injectable()
export class GridCard<T extends PlaneTypes> extends PlanePositionSizeAbstract {
  data?: GridCardData<T> | undefined;
  key?: string;
  onClick?: () => Promise<void> | void;

  private _size: PlaneSize = { width: 0, height: 0 };

  setSize = (size: PlaneSize) => {
    this._size = size;
  };

  get size(): PlaneSize {
    return this._size;
  }

  init = <P extends PlaneTypes>(
    data?: GridCardData<P>,
    type = PlaneTypes.Card_ShopFloor_Product
  ) => {
    // @ts-expect-error
    this.data = data;
    this.type = type;
  };

  type = PlaneTypes.Card_ShopFloor_Product;

  parentHero?: GridCard<PlaneTypes>;
  blockHover?: boolean;
  visible = new ObservableProp(true);
  backgroundColor?: string;
}

container.bind(GridCard).toSelf().inTransientScope();

type GetCardProps<T extends PlaneTypes> = {
  data?: GridCardData<T>;
  type?: PlaneTypes;
  size?: PlaneSize;
  parentHero?: GridCard<PlaneTypes>;
  position?: Position2D;
  parent?: IPlaneParent;
  blockHover?: boolean;
  backgroundColor?: string;
  isParenHero?: boolean;
};

export const getCard = <T extends PlaneTypes>({
  data,
  type = PlaneTypes.Card_ShopFloor_Product,
  size = { width: 0, height: 0 },
  parentHero,
  position = { x: 0, y: 0 },
  parent,
  blockHover,
  backgroundColor,
}: GetCardProps<T>) => {
  const card = container.get<GridCard<T>>(GridCard);
  card.init(data);
  card.type = type;
  card.setSize({ ...size });
  card.setPosition({ ...position });
  card.parentHero = parentHero;
  parent && card.setParent(parent);
  blockHover && (card.blockHover = blockHover);
  backgroundColor && (card.backgroundColor = backgroundColor);

  return card;
};

export const getGap = (
  size: PlaneSize,
  color = 'black',
  position = { x: 0, y: 0 }
) => {
  const key = `gap_${Math.random()}`;

  const card = getCard({
    type: PlaneTypes.Gap,
    size,
    // @ts-expect-error
    data: { id: 0, key },
    position,
  });
  card.key = card.data?.key;
  card.backgroundColor = color;

  return card;
};
